import { DownloadComponent } from './download/download.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page404Component } from './shared/page404/page404.component';
import { PrzerwaComponent } from './przerwa/przerwa.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { RegulationsComponent } from './regulations/regulations.component';

const routes: Routes = [
  {
    path: 'kerastase-nutritive-grafika',
    loadChildren: () =>
      import('./kerastase-nutritive-grafika/kerastase-nutritive-grafika.module').then(
        (m) => m.KerastaseNutritiveGrafikaModule,
      ),
  },
  //Temporarily disabled
  // {
  //   path: 'fotograf',
  //   loadChildren: () => import('./photographer/photographer.module')
  //     .then(m => m.PhotographerModule)
  // },
  //Temporarily disabled
  // {
  //   path: 'artykuly/steampod-3-0-stylizacja-i-pielegnacja',
  //   redirectTo: 'artykuly/steampod-3-0-w-limitowanej-edycji',
  //   pathMatch: 'full',
  // },
  {
    path: 'business',
    loadChildren: () => import('./biznes/biznes.module').then((m) => m.BiznesModule),
  },
  {
    path: 'download-file',
    loadChildren: () => import('./download/download.module').then((m) => m.DownloadModule),
  },

  {
    path: 'old-biznes',
    loadChildren: () => import('./business/business.module').then((m) => m.BusinessModule),
  },
  // {
  //   path: 'zapisyszkoleniaonline',
  //   loadChildren: () => import('./zapisyszkoleniaonline/zapisyszkoleniaonline.module').then(m => m.ZapisyszkoleniaonlineModule)
  // },
  {
    path: 'zapisyszkoleniaonline',
    redirectTo: '/biznes/zapisy-szkolenia-online',
  },
  {
    path: 'przejdz_na_online',
    loadChildren: () => import('./go-online/go-online.module').then((m) => m.GoOnlineModule),
  },
  {
    path: 'salonexpert-zgoda-marketingowa-booksy',
    loadChildren: () => import('./consumer/lp/mailing-thanks/mailing-thanks.module').then((m) => m.MailingThanksModule),
  },
  {
    path: 'akademia-fryzjera-2023',
    redirectTo: 'akademia-fryzjera-2024',
    pathMatch: 'full',
  },
  {
    path: 'konkurs_milkytrend',
    redirectTo: 'download-file/salonexpert-konkurs_milkytrend',
    pathMatch: 'full',
  },
  {
    path: 'konkurs-dia-color-tytanowy-braz',
    redirectTo: 'download-file/salonexpert-konkurs-dia-color-tytanowy-braz',
    pathMatch: 'full',
  },
  {
    path: 'polityka-prywatnosci',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'regulamin-programu',
    component: RegulationsComponent,
  },
  {
    path: 'akademia-fryzjera-2024',
    loadChildren: () => import('./consumer/lp/academy/academy.module').then((m) => m.AcademyModule),
  },
  {
    path: 'testowanieredken',
    loadChildren: () => import('./redken-main/redken-lp/redken-lp.module').then((m) => m.RedkenLpModule),
  },
  {
    path: 'salonexpert-baltics-access',
    loadChildren: () =>
      import('./salon-expert-baltics-access/salon-expert-baltics-access.component').then(
        (m) => m.SalonExpertBalticsAccessModule,
      ),
  },
  {
    path: '',
    loadChildren: () => import('./consumer/consumer.module').then((m) => m.ConsumerModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
